<!--抽奖面板-->
<template>
  <van-popup
    v-model="popupShow"
    :close-on-click-overlay="false"
    get-container="body"
    :class="[isPc?'popup-p-pc':'popup-p']"
  >
    <div
      class="close-icon"
      @click="closePopup"
    >
      <van-icon
        name="close"
        color="#FFF"
        :size="isPc?'0.39333rem':'0.35rem'"
      />
    </div>
    <div
      class="lottery-draw-p"
      :style="{background: 'url('+drawBgImg+') center center no-repeat', backgroundSize: isPc?'4.9rem 6.9rem':'3.9rem 5.5rem'}"
    >
      <div
        class="popup-p-status"
        v-if="(haveBeginTime>0&&!isCountdown) || (haveBeginTime<=0&&haveEndTime<=0)"
      >{{drawTip}}</div>
      <div
        class="popup-p-status"
        v-if="haveBeginTime>0&&isCountdown"
      >{{content.startCountdown}}：
        <van-count-down
          :time="haveBeginTime"
          @finish="beginCountFinish"
        />
      </div>
      <div
        class="popup-p-status"
        v-if="haveBeginTime<=0 && haveEndTime>0"
      >{{content.endCountdown}}：
        <van-count-down
          :time="haveEndTime"
          @finish="endCountFinish"
        />
      </div>

      <div class="popup-p-draw">
        <div
          v-for="(item,index) in prizeList"
          :key="index"
          :class="['draw-item',currentIndex==index?'mask':'']"
          :style="{background: 'url('+drawItemBgImg+') center center no-repeat', backgroundSize: isPc?'1.27rem 1.19rem':'0.93rem 0.86rem'}"
        >
          <van-image
            class="true-gift"
            v-if="item.name=='奖品'"
            width="0.68rem"
            height="0.68rem"
            :src="item.src"
          />
          <van-image
            v-else
            class="thank-gift"
            width="0.49rem"
            height="0.49rem"
            :src="item.src"
          />
          <div>{{ index % 2 == 1 ? item.name : ''}}</div>
        </div>
        <div
          :class="['draw-item',canDraw?'':'grayscale']"
          :style="{background: 'url('+drawCenterBgImg+') center center no-repeat', cursor: 'pointer', backgroundSize: isPc?'1.27rem 1.19rem':'0.93rem 0.86rem'}"
          @click="drawClick"
        >
          <div>{{drawBtnDesc}}</div>
        </div>
      </div>
      <div
        class="popup-p-num"
        v-if="raffleStatus == 'In Progress'"
      >{{content.last}}{{numberResidue}}{{content.lastDrawNums}}</div>
      <div class="popup-p-tip">
        <div
          class="tip-btn"
          v-if="isGet"
        >
          <van-button @click="seeMyGift">{{content.seeMyGift}}</van-button>
        </div>
        <div class="tip-desc">
          <div class="tip-desc-title">{{content.drawRule}}</div>
          <div
            class="tip-desc-cont"
            v-html="rule"
          >
          </div>
          <div class="tip-slogan">{{slogan}}</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from '@/utils/index.js'
import LotteryDraw from './LotteryDraw.js'
import { postPrizeDetail, postAddRaffleRecord, postGetRaffleWinning } from '@/models/common'
export default {
  data() {
    return {
      popupShow: false, // 抽奖面板是否显示
      drawBgImg: require('@/assets/imgs/draw-p.png'),
      drawItemBgImg: require('@/assets/imgs/draw-item.png'),
      drawCenterBgImg: require('@/assets/imgs/draw-a.png'),
      prizeList: [], // 全部礼品列表
      currentIndex: -1,
      drawBtnDesc: '', // 抽奖按钮文字
      drawTip: '', // 抽奖顶部提示
      rule: '', // 	规则
      slogan: '', // 广告语
      isCountdown: false, // 是否倒计时
      isGet: false, // 是否中奖
      numberResidue: 0, // 剩余抽奖次数
      raffleStatus: '', // 当前抽奖状态Not Started：未开始 In Progress：进行中 Finish：已结束
      raffleId: '', // 当前抽奖环节ID
      haveBeginTime: 0, // 距离开始倒计时
      haveEndTime: 0, // 距离结束倒计时
      end_time: '', // 结束时间
      drawing: false, // 是否滚动抽奖中
      streamId: '',
      memberId: '',
    }
  },
  computed: {
    // 是否可抽奖
    canDraw: function () {
      return this.drawBtnDesc == this.content.drawNow
    },
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc'])
  },
  methods: {
    async show(obj) {
      this.drawBtnDesc = this.content.notstart
      this.streamId = obj.streamId
      this.memberId = obj.memberId
      await this.initPrizeList()
      this.popupShow = true
    },
    // 关闭面板
    close() {
      this.currentIndex = -1
      this.popupShow = false
    },
    // 初始化奖品
    async initPrizeList() {
      const _this = this
      const res = await postPrizeDetail({
        stream_id: this.streamId,
        member_id: this.memberId
      })
      if (res.data.code == 0) {
        let gifts = res.data.data.content.map((item) => { return { id: item.id, src: item.pic, name: '奖品', type: '1' } })
        let thx = {
          src: require('@/assets/imgs/happy.png'),
          name: _this.content.thx,
          type: '0'
        }
        this.prizeList = [{ ...gifts[0] }, { ...thx }, { ...gifts[1] }, { ...thx }, { ...gifts[2] }, { ...thx }, { ...gifts[3] }, { ...thx }]

        this.rule = res.data.data.rule
        this.slogan = res.data.data.slogan
        this.isCountdown = res.data.data.is_countdown == 1
        this.isGet = res.data.data.prize_count > 0
        this.numberResidue = res.data.data.number_residue
        this.raffleStatus = res.data.data.raffle_status
        this.raffleId = res.data.data.id
        // if (this.isGet) {
        //   // 已经抽中
        //   this.drawBtnDesc = '未开始'
        //   this.haveBeginTime = 0
        //   this.haveEndTime = 0
        //   this.drawTip = '抽奖未开始'
        //   this.raffleStatus = 'Not Started'
        // } else {
        if (this.raffleStatus == 'Not Started') {
          this.drawBtnDesc = this.content.notstart
        } else if (this.raffleStatus == 'In Progress') {
          if(this.numberResidue <= 0) {
            this.drawBtnDesc = this.content.drawOver
          } else {
            this.drawBtnDesc = this.content.drawNow
          }
        } else if (this.raffleStatus == 'Finish') {
          this.drawBtnDesc = this.content.hasEnd
        }
        // 距离开始时间倒计时
        this.haveBeginTime = new Date(res.data.data.start_time.replace(/-/g, '\/')).getTime() - new Date()
        // 距离结束时间倒计时
        this.end_time = res.data.data.end_time
        this.haveEndTime = new Date(res.data.data.end_time.replace(/-/g, '\/')).getTime() - new Date()
        if (this.haveBeginTime > 0 || (this.haveEndTime <= 0 && this.raffleStatus == 'Not Started')) {
          // 开始倒计时
          this.drawTip = this.content.drawnotstart
        } else if (this.haveEndTime > 0) {
          // 结束倒计时
          this.drawTip = this.content.drawing
        } else {
          // 已结束
          this.drawTip = this.content.drawend
        }
        // }
      }
    },
    // 开始滚动抽奖
    startDraw() {
      this.currentIndex = -1
      let totalCount = 2, winingIndex = 0
      if (!this._luckDraw) {
        this._luckDraw = debounce(async () => {
          if (this.drawing) return
          this.drawing = true
          if (this.numberResidue <= 0) {
            this.drawing = false
            return this.$toast(this.content.drawLessNum)
          }
          const res = await postAddRaffleRecord({
            stream_id: this.streamId,
            member_id: this.memberId,
            raffle_id: this.raffleId
          })
          if (res.data.code == 0) {
            // 判断是否中奖、中奖信息
            if (res.data.data.is_prize) {
              // 中奖
              winingIndex = this.prizeList.findIndex(
                (item) => item.id === res.data.data.prize_id
              )
            } else {
              // 随机不中奖
              let indexList = []
              for (let i = 0, len = this.prizeList.length; i < len; i++) {
                this.prizeList[i].type == '0' && indexList.push(i)
              }
              // 随机取"谢谢参与"的下标
              winingIndex = indexList[Math.floor(Math.random() * indexList.length)]
            }
            new LotteryDraw(
              {
                domData: this.prizeList,
                startIndex: this.currentIndex,
                totalCount,
                winingIndex,
                speed: 150
              },
              (index, count) => {
                this.currentIndex = index;
                if (winingIndex == index && totalCount == count) {
                  setTimeout(() => {
                    this.drawing = false
                    if (res.data.data.is_prize) {
                      this.$emit('success', { ...res.data.data.prize_result, type: 'edit' })
                    } else {
                      this.$emit('fail')
                    }
                  }, 500);
                }
              }
            );
          } else {
            this.drawing = false
            this.$toast(this.lanuage == 'Chinese' ? '抽奖异常' : 'Error')
          }
        }, 200)
      }
      this._luckDraw()
    },
    // 点击抽奖按钮
    drawClick() {
      if (this.canDraw) {
        // 可抽奖
        this.startDraw()
      }
    },
    // 查看我的奖品
    async seeMyGift() {
      const res = await postGetRaffleWinning({
        stream_id: this.streamId,
        member_id: this.memberId
      })
      if (res.data.code == 0) {
        let data = res.data.data
        // 避免中奖后不填的情形，如果都填了展示详情，如果有没填的展示编辑
        if (data.name != '' && data.tel != '' && data.email != '' && data.receiving_address != ''
          && data.name != null && data.tel != null && data.email != null && data.receiving_address != null) {
          this.$emit('success', { ...res.data.data, type: 'detail' })
        } else {
          this.$emit('success', { ...res.data.data, type: 'edit' })
        }
      } else {
        this.$toast(this.lanuage == 'Chinese' ? '查看我的奖品异常' : 'Error')
      }
    },
    // 距离开始倒计时
    beginCountFinish() {
      this.haveBeginTime = 0
      if(this.numberResidue <= 0) {
        this.drawBtnDesc = this.content.drawOver
      } else {
        this.drawBtnDesc = this.content.drawNow
      }
      this.drawTip = this.content.drawing
      this.raffleStatus = 'In Progress'
      // 距离结束时间倒计时
      this.haveEndTime = new Date(this.end_time.replace(/-/g, '\/')).getTime() - new Date()
    },
    // 距离结束倒计时
    endCountFinish() {
      this.haveEndTime = 0
      this.drawBtnDesc = this.content.hasEnd
      this.drawTip = this.content.drawend
      this.raffleStatus = 'Finish'
    },
    // 点击关闭按钮
    closePopup() {
      if (!this.drawing) {
        this.close()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.popup-p-pc {
  background-color: transparent;
  overflow-y: visible;
  .close-icon {
    position: absolute;
    top: -0.41333rem;
    right: 0.41333rem;
    color: #fff;
    display: flex;
    cursor: pointer;
  }
  .lottery-draw-p {
    width: 4.9rem;
    height: 6.9rem;
    position: relative;
    .popup-p-status {
      font-size: 0.19rem;
      color: #fff;
      font-weight: bold;
      position: absolute;
      top: 0.33rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      /deep/.van-count-down {
        font-size: 0.19rem;
        color: #fff;
      }
    }
    .popup-p-draw {
      position: relative;
      top: 0.86rem;
      left: 0.63rem;
      width: 3.64rem;
      height: 3.4rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .draw-item {
        width: 1.09rem;
        height: 0.84rem;
        text-align: center;
        border: 0.03rem solid #fff3f3;
        background-color: #fff3f3;
        border-radius: 10px;
        font-size: 0.16rem;
        color: #a20e07;
        padding-bottom: 0.2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .true-gift {
        }
        .thank-gift {
          margin: 0.08rem;
        }
        &:nth-child(1) {
          position: absolute;
          top: 0;
          left: 0;
        }
        &:nth-child(2) {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%);
        }
        &:nth-child(3) {
          position: absolute;
          top: 0;
          right: 0;
        }
        &:nth-child(4) {
          position: absolute;
          top: 1.15rem;
          right: 0;
        }
        &:nth-child(5) {
          position: absolute;
          bottom: 0;
          right: 0;
        }
        &:nth-child(6) {
          position: absolute;
          left: 50%;
          transform: translate(-50%);
          bottom: 0;
        }
        &:nth-child(7) {
          position: absolute;
          left: 0;
          bottom: 0;
        }
        &:nth-child(8) {
          position: absolute;
          left: 0;
          top: 1.15rem;
        }
        &:nth-child(9) {
          position: absolute;
          top: 1.15rem;
          left: 50%;
          transform: translate(-50%);
          font-size: 0.23rem;
          padding-left: 0.1rem;
          padding-right: 0.1rem;
          box-sizing: border-box;
          color: #ff2602;
          font-weight: bold;
          width: 1.15rem;
          height: 1.09rem;
        }
      }
      .mask {
        border: 0.03rem solid #4cf3e1;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.3);
          border-radius: 0.13333rem;
        }
      }
      .grayscale {
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
        padding-left: 0 !important;
        padding-right: 0 !important;
        color: #858585 !important;
      }
    }
    .popup-p-num {
      font-size: 0.18rem;
      color: #fff;
      font-weight: bold;
      position: absolute;
      bottom: 2.1rem;
      left: 50%;
      transform: translateX(-50%);
    }
    .popup-p-tip {
      position: absolute;
      top: 5.15rem;
      left: 0.59rem;
      width: 3.7rem;
      .tip-btn {
        text-align: center;
        display: flex;
        justify-content: center;
        .van-button {
          // width: 1.03rem;
          height: 0.25rem;
          background: #fde73a;
          border-radius: 6px;
          font-size: 0.16rem;
          color: #cd410a;
        }
      }
      .tip-desc {
        height: 1.1rem;
        overflow-y: auto;
        .tip-desc-title {
          font-size: 0.16rem;
          color: #ffefb6;
          font-weight: bold;
        }
        .tip-desc-cont {
          font-size: 0.1rem;
          color: #ffefb6;
          margin-top: 0.03rem;
          white-space: pre-wrap;
          /deep/pre {
            white-space: pre-wrap;
            margin: 0;
          }
        }
        .tip-slogan {
          font-size: 0.1rem;
          color: #ffefb6;
          text-align: center;
          margin-top: 0.03rem;
        }
      }
    }
  }
}
.popup-p {
  background-color: transparent;
  overflow-y: visible;
  .close-icon {
    position: absolute;
    top: -0.41333rem;
    right: 0.41333rem;
    color: #fff;
    display: flex;
    cursor: pointer;
  }
  .lottery-draw-p {
    width: 3.9rem;
    height: 5.5rem;
    position: relative;
    .popup-p-status {
      font-size: 0.15rem;
      color: #fff;
      font-weight: bold;
      position: absolute;
      top: 0.26rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      /deep/.van-count-down {
        font-size: 0.15rem;
        color: #fff;
      }
    }
    .popup-p-draw {
      position: relative;
      top: 0.71rem;
      left: 0.51rem;
      width: 2.91rem;
      height: 2.68rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .draw-item {
        width: 0.87rem;
        height: 0.7rem;
        text-align: center;
        border: 0.03rem solid #fff3f3;
        background-color: #fff3f3;
        border-radius: 10px;
        font-size: 0.12rem;
        color: #a20e07;
        padding-bottom: 0.1rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .true-gift {
        }
        .thank-gift {
          margin: 0.08rem;
        }
        &:nth-child(1) {
          position: absolute;
          top: 0;
          left: 0;
        }
        &:nth-child(2) {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%);
        }
        &:nth-child(3) {
          position: absolute;
          top: 0;
          right: 0;
        }
        &:nth-child(4) {
          position: absolute;
          top: 0.91rem;
          right: 0;
        }
        &:nth-child(5) {
          position: absolute;
          bottom: 0;
          right: 0;
        }
        &:nth-child(6) {
          position: absolute;
          left: 50%;
          transform: translate(-50%);
          bottom: 0;
        }
        &:nth-child(7) {
          position: absolute;
          left: 0;
          bottom: 0;
        }
        &:nth-child(8) {
          position: absolute;
          left: 0;
          top: 0.91rem;
        }
        &:nth-child(9) {
          position: absolute;
          top: 0.91rem;
          left: 50%;
          transform: translate(-50%);
          font-size: 0.23rem;
          padding-left: 0.1rem;
          padding-right: 0.1rem;
          box-sizing: border-box;
          color: #ff2602;
          font-weight: bold;
          width: 0.93rem;
          height: 0.86rem;
        }
      }
      .mask {
        border: 0.03rem solid #4cf3e1;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.3);
          border-radius: 0.13333rem;
        }
      }
      .grayscale {
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
        padding-left: 0 !important;
        padding-right: 0 !important;
        color: #858585 !important;
      }
    }
    .popup-p-num {
      font-size: 0.15rem;
      color: #fff;
      font-weight: bold;
      position: absolute;
      bottom: 1.65rem;
      left: 50%;
      transform: translateX(-50%);
    }
    .popup-p-tip {
      position: absolute;
      top: 4.05rem;
      left: 0.59rem;
      width: 2.7rem;
      .tip-btn {
        text-align: center;
        display: flex;
        justify-content: center;
        .van-button {
          // width: 1.03rem;
          height: 0.25rem;
          background: #fde73a;
          border-radius: 6px;
          font-size: 0.12rem;
          color: #cd410a;
        }
      }
      .tip-desc {
        height: 0.9rem;
        overflow-y: auto;
        .tip-desc-title {
          font-size: 0.15rem;
          color: #ffefb6;
          font-weight: bold;
        }
        .tip-desc-cont {
          font-size: 0.1rem;
          color: #ffefb6;
          margin-top: 0.03rem;
          white-space: pre-wrap;
          /deep/pre {
            white-space: pre-wrap;
            margin: 0;
          }
        }
        .tip-slogan {
          font-size: 0.1rem;
          color: #ffefb6;
          text-align: center;
          margin-top: 0.03rem;
        }
      }
    }
  }
}
</style>